
$(document).ready(function () {    

  // function filterImages(show_image = null) {
  //   var selectedValue = $('.is-color-swatch input[type="radio"]:checked').val()?.toLowerCase() || '';
  //   let count = 1;    
  //   if (!$('.see-all-images').hasClass('not-active')) {
  //     show_image = 15;
  //   }
  //   let main_images_ele = $('product-media-grid [data-media-main]');

  //   $('.product-all-list-media .product-media-col').hide();
  //   $('.product-all-list-media img').each(function () {
  //     if (show_image !== null && count > show_image) {
  //       return false;
  //     }
  //     var imageAlt = ($(this).attr('alt') || '').toLowerCase();

  //     // Always show if alt is empty, otherwise match selected color
  //     if (imageAlt === '' || imageAlt.includes(selectedValue)) {
  //       $(this).closest('.product-media-col').show();        
  //       // let clone = $(this).closest('.product-media-col').clone().show();   
  //       // $(this).closest('.product-media-col').remove();     
  //       // main_images_ele.prepend(clone);
  //       count++;
  //     }
  //   });

  //   //  Show button only if there are more than 15 matching images AND not clicked before
  //   var totalVisible = $('.product-all-list-media .product-media-col:visible').length;
  //   var totalImages = $('.product-all-list-media img').filter(function () {
  //     var imageAlt = ($(this).attr('alt') || '').toLowerCase();
  //     return (imageAlt === '' || imageAlt.includes(selectedValue));
  //   }).length;

  //   if (totalImages > 15 && !$('.see-all-images').hasClass('not-active')) {
  //     $('.see-all-images').show();
  //   } else {
  //     $('.see-all-images').hide();
  //   }
  // }

  // // Run once on page load
  // var show_image = 15;
  // filterImages(show_image);

  // // Run again on swatch change
  // $(document).on('change click', '.is-color-swatch input[type="radio"], .is-color-swatch label', function () {
  //   filterImages();
  // });

  // See All Images button click
  // $('.see-all-images button').click(function () {
  //   $('.hidden-product-media').slideDown();
  //   $('.see-all-images').fadeOut().addClass('not-active'); // prevent re-show
  //   filterImages();
  // });

  // sign-up-offer 10% click event
  if($('.sign-up-offer').length > 0){
    $('.sign-up-offer').click(function (e) {
      e.preventDefault();
      $('.kl-teaser-TgQkxm').trigger('click');
    });
  }
  

});

// document.addEventListener("DOMContentLoaded", function() {

//   function showPairOrColorImage() {  
     

//     if (jQuery('.qty-btn.active').is('[data-btn-box]')) {    

//       var selectedValue = $('.is-color-swatch input[type="radio"]:checked').val()?.toLowerCase() || '';
//       //console.log('selected value', selectedValue);   

//       if($('.is-material-swatch').length >0){
//         var selectedMeterial = $('.is-material-swatch input[type="radio"]:checked').val()?.toLowerCase() || '';
//         selectedValue = selectedValue+'-'+selectedMeterial;
//       }  
      
//       if($('.is_gem_size_swatch').length >0){
//         var selectedGemSize = $('.is_gem_size_swatch input[type="radio"]:checked').val()?.toLowerCase() || '';
//         selectedValue = selectedValue+'-'+selectedGemSize;
//       } 

//       if($('.is_gem_color_swatch').length >0){
//         var selectedGemColor = $('.is_gem_color_swatch input[type="radio"]:checked').val()?.toLowerCase() || '';
//         selectedValue = selectedValue+'-'+selectedGemColor;
//       }
      
//       var boxValue = jQuery('.qty-btn.active').attr('data-btn-box');
//       selectedValue = selectedValue +'-'+ boxValue;

          
//       // Mobile code 
//       if (document.querySelector('.product-med-mob')) {      
//         $('.product-med-mob').each(function () {
          
//           var imageAlt = ($(this).attr('alt') || '').toLowerCase();
//           var imgIndex = ($(this).attr('data-thumb-index') || '').toLowerCase();          

//           // Always show if alt is empty, otherwise match selected color
//           if (imageAlt != '' && imageAlt.includes(selectedValue)) {      
//             //console.log(imageAlt, 'imageAlt');   
//               // Get the swiper DOM element
//             var swiperEl = document.querySelector('.swiper.custom-aspect-ratio'); 
//             if (swiperEl) {
//               // Poll until swiperEl.swiper exists
//               var checkSwiper = setInterval(function() {
//                 if (swiperEl.swiper) {
//                   clearInterval(checkSwiper); // stop polling
//                   var swiperInstance = swiperEl.swiper;
//                   swiperInstance.slideTo(parseInt(imgIndex)); // go to desired slide
                  
//                 }
//               }, 50); // check every 50ms
//             } else {
//               console.log('Element not found');
//             }
                
//           }

//         });

//       }

//        // Desktop code 
//       $('.product-all-list-media .product-media-col').each(function () {
        
//         var imageAlt = ($(this).find('img').attr('alt') || '').toLowerCase();

//         // Always show if alt is empty, otherwise match selected color
//         if (imageAlt != '' && imageAlt.includes(selectedValue)) {
//           $('.product-all-list-media .product-media-col').removeClass('active');  
//           $(this).addClass('active');   

//             //console.log(' $(this)',  $(this), imageAlt, 'imageAlt');      
//         }
//       });
//     }else{
//       // $('.product-all-list-media .product-media-col').each(function () {
        
//       //   var imageAlt = ($(this).find('img').attr('alt') || '').toLowerCase();

//       //   // Always show if alt is empty, otherwise match selected color
//       //   if (imageAlt != '' && imageAlt.includes(selectedValue)) {
//       //     $('.product-all-list-media .product-media-col').removeClass('active');
//       //     $(this).addClass('active');   
//       //     //console.log(' $(this)',  $(this), imageAlt, 'imageAlt');           
//       //   }
//       // });      

//     }
//   }

//     $(document).on('change click', '.is-color-swatch input[type="radio"], .is-color-swatch label', function () {      
//       showPairOrColorImage();      
//     });

//     $(document).on('change click', '.is-material-swatch input[type="radio"], .is-material-swatch label', function () {
//       showPairOrColorImage();  
//     });

//     $(document).on('change click', '.is_gem_size_swatch input[type="radio"], .is_gem_size_swatch label', function () {
//       showPairOrColorImage();  
//     });

//     $(document).on('change click', '.is_gem_color_swatch input[type="radio"], .is_gem_color_swatch label', function () {
//       showPairOrColorImage();  
//     });
    
//     $(document).on('click', '.qty-btns .qty-btn', function () {
//       showPairOrColorImage();
//     });
  

//   setTimeout(() => {    
//     showPairOrColorImage();
//   }, 500);  
  

// });



function hasAllKeywords(altText, requiredKeywords) {
    if (!altText || requiredKeywords.length === 0) return false;
    const lowerAlt = altText.toLowerCase();
    return requiredKeywords.every(keyword => {
        if (!keyword) return true;
        const clean = keyword.trim();
        if (clean === '') return true;
        const regex = new RegExp(`\\b${clean.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}\\b`);
        return regex.test(lowerAlt);
    });
}

function getSelectedParts() {
    const parts = [];

    const color = $('.is-color-swatch input[type="radio"]:checked').val();
    if (color) parts.push(color.toLowerCase().trim());

    const material = $('.is-material-swatch input[type="radio"]:checked').val();
    if (material) parts.push(material.toLowerCase().trim());

    const gemSize = $('.is_gem_size_swatch input[type="radio"]:checked').val();
    if (gemSize) parts.push(gemSize.toLowerCase().trim());

    const gemColor = $('.is_gem_color_swatch input[type="radio"]:checked').val();
    if (gemColor) parts.push(gemColor.toLowerCase().trim());

    const box = $('.qty-btn.active[data-btn-box]').attr('data-btn-box');
    if (box) parts.push(box.toLowerCase().trim());

    return parts.filter(Boolean);
}

function showPairOrColorImage() {
    if (!$('.qty-btn.active').is('[data-btn-box]')) return;

    const required = getSelectedParts();
    if (required.length === 0) return;

    let mobileIndex = -1;

    $('.product-med-mob').each(function () {
        const alt = ($(this).attr('alt') || '').toLowerCase();
        const index = parseInt($(this).attr('data-thumb-index') || '-1', 10);

        if (hasAllKeywords(alt, required)) {
            if (index >= 0 && mobileIndex === -1) mobileIndex = index;
        }
    });

    if (mobileIndex !== -1) {
        const swiperEl = document.querySelector('.swiper.custom-aspect-ratio');
        if (swiperEl?.swiper) {
            swiperEl.swiper.slideTo(mobileIndex);
            document .querySelectorAll('.swiper-slide.product-med-mob').forEach(el =>el.classList.remove('active-index'));
            document.querySelector('.swiper-slide-thumb-active').classList.add('active-index');
        }
    }

    $('.product-all-list-media .product-media-col').each(function () {
        const alt = ($(this).find('img').attr('alt') || '').toLowerCase();
        if (hasAllKeywords(alt, required)) {
            $('.product-all-list-media .product-media-col').removeClass('active');
            $(this).addClass('active');
            return false;
        }
    });
}

$(document).on('change click', '.is-color-swatch input, .is-color-swatch label, .is-material-swatch input, .is-material-swatch label, .is_gem_color_swatch input, .is_gem_color_swatch label', function () {
     const getText = $('.btn-pair.qty-btn.active').text().trim();    
  if (getText === 'Pair') {
        showPairOrColorImage();
    } else {
        setTimeout(() => {
            showPairOrColorImage();
        }, 100);
    }
});

$(document).on('change click', '.is_gem_size_swatch input, .is_gem_size_swatch label', function () {
    const getText = $('.btn-pair.qty-btn.active').text().trim();
    if (getText === 'Pair') {
        showPairOrColorImage();
    } else {
        setTimeout(() => {
            showPairOrColorImage();
        },100);
    }
});

$(document).on('click', '.qty-btns .qty-btn', function () {
    $('.qty-btn').removeClass('active');
    $(this).addClass('active');
    showPairOrColorImage();
});
var getHeight =  $('.product-form-block[data-block-id="price"]').height();
$('.product-form-block[data-block-id="price"]').height(getHeight);
setTimeout(showPairOrColorImage, 800);
























/** Who we are page section get-pierced triggers*/ 
document.addEventListener("DOMContentLoaded", function() {
  const hash = window.location.hash;
  if (hash) {
    const target = document.querySelector(hash) || document.querySelector(hash.replace('#', '.'));
    if (target) {
      // Get sticky header height
      const header = document.querySelector(".site-header"); 
      const headerHeight = header ? header.offsetHeight : 0;

      // Calculate target position minus header height
      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight - 10; // extra 10px padding

      // Smooth scroll with offset
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }

    // Clean URL (remove hash)
    history.replaceState(null, null, window.location.pathname);
  }
  
});

// PDP page Learn more Button open the Redo app popup 
document.addEventListener('DOMContentLoaded', () => {
  const outsideBtn = document.querySelector('.free-return-learn-more');
  if (outsideBtn) {
    outsideBtn.addEventListener('click', () => {
      const host = document.querySelector('redo-shopify-checkbox');
      if(host){
        const btn  = host.shadowRoot.querySelector('[data-target="checkbox-root"] button');
        if (btn) btn.click();
      }     

    });
  } 
});
// jQuery('body').on('click','.klaviyo-close-form', function(){
//     window.location.reload();
// });
document.addEventListener('DOMContentLoaded', () => {
  const thumbnails = document.querySelector('[data-media-thumbnails]');
  if (!thumbnails) return;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  document.addEventListener('touchstart', (e) => {
    if (!isMobile()) return;

    const touchedInside = thumbnails.contains(e.target);

    if (touchedInside) {
      // Touching thumbnails → REMOVE class
      document.body.classList.remove('product-thumb-stop');
    } else {
      // Touching anywhere else → ADD class
      document.body.classList.add('product-thumb-stop');
      const thumbWrapper = document.querySelector('[data-media-thumbnails] .swiper-wrapper.thumb');

      setTimeout(function(){
        if (thumbWrapper) {
         thumbWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
        }
      }, 500);
      
    }
  }, { passive: true });
  
});